import React, { useState, useEffect } from 'react'
import { RiDeleteBin5Line } from 'react-icons/ri'
import { FaUndo } from 'react-icons/fa'

function ClearDb(props) {
  const { userDataFromStorage ,coloredTheme} = props;

  return (
    <div className={userDataFromStorage.user_role === 'admin' ? 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden' : 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden'}>
      <p className='font-[600] lg:text-[1.6rem] md:text-[1.5rem] text-[1.2rem] xl:text-[2rem] text-gray-800 tracking-wider'>Confirm Deletion</p>
      <p className=' xl:text-[1.2rem] md:text-[1rem] text-[0.9rem] lg:text-[1rem] mt-2 text-gray-600 tracking-wider'>Continuing will delete all data in the database.</p>
      <p className='xl:text-[1.2rem] md:text-[1rem] text-[0.9rem] lg:text-[1rem] mt-2 text-gray-600 tracking-wider'>Please confirm that this is what you want to do.</p>

      <button style={{ backgroundColor: coloredTheme }} className='md:mt-12 mt-6 flex justify-center items-center space-x-2 text-white  rounded  p-[1rem]'>
        <RiDeleteBin5Line className='text-xl' />
        <p>Confirm - Delete All Data</p>
      </button>
      <button style={{ backgroundColor: coloredTheme }} className='mt-6  flex justify-center items-center space-x-2 text-white  rounded  p-[1rem]'>
        <FaUndo className='text-xl' />
        <p>Cancel Deletion</p>
      </button>
    </div>
  )
}

export default ClearDb